/**
 * 配車スケジュール一覧用 変数定義
 */
import { reactive, ref } from "vue";
import {
  SearchParams,
  UserEditForm,
  RentalContractEditForm,
} from "./interface";

export const schedules = reactive({
  daily: Array,
  unset: Array,
});

export const isShow = reactive({
  loading: true,
  display: false,
  initDisplay: true,
  canvas: true,
  render: true,
});

export const isInsUpd = reactive({
    reload: false,
});

export const searchParams = reactive<SearchParams>({
  start_ymd: "",
  end_ymd: "",
  user_id: 0,
  car_id: 0,
  car_model_id: 0,
  car: "",
  department_id: 0,
  type_id: 0,
});

export const anchor = "is_anchor";

/* 担当者変更Modal */
export const userEditForm = reactive<UserEditForm>({
  id: 0,
  users: [],
  route: "",
});
export const usersForMultiPulldownByVue = reactive({
  users: Array(),
});

export const usersForSinglePulldownByVue = reactive({
  users: Array(),
});

export const carModelsForPulldownByVue = reactive({
  carModels: Array(),
});

export const driverLicenseTypesForPulldownByVue = reactive({
  driverLicenseTypes: Array(),
});

export const driverLicenseExpireYearsForPulldownByVue = reactive({
  driver_license_expire_years: Array(),
});

export const usageObjectivesForPulldownByVue = reactive({
  usageObjectives: Array(),
});

/* 貸渡契約書Modal */
export const vueCanvasDrawingRef = ref<any>(null);
export const rentalContractEditForm = reactive<RentalContractEditForm>({
  // RentalContracts
  id: 0,
  scheduleId: 0,
  typeId: 0,
  slipNo: "",
  managerId: 0,
  dispatchDate: "",
  rentCarNo: "",
  rentCarId: 0,
  dischargeAmount: 0,
  nocSubscriptionAmount: 0,
  contractorCompanyName: "",
  contractorAddress: "",
  contractorManager: "",
  contractorTel: "",
  driverName: "",
  driverSex: 0,
  driverBirthday: "",
  driverAddress: "",
  driverTel: "",
  driverLicenseNo: 0,
  drivingLicenseTypeId: 0,
  driverLicenseExpireYear: 0,
  lentDate: "",
  lentTime: "",
  lentDateDrivingDistance: 0,
  returnDate: "",
  returnTime: "",
  returnDateDrivingDistance: 0,
  vehicleInspectionExpiryDate: "",
  maintenanceDate: "",
  maintenancePersonId: 0,
  usageObjectiveId: 0,
  destAddress: "",
  destManager: "",
  destTel: "",
  fuel: 0,
  registrationAt: "",

  // carChecksheets
  carChecksheetId: 0,
  rentContractId: 0,
  checkManagerId: 0,
  processedDate: "",
  brakeRoom: false,
  brakeEffective: false,
  brakeFluid: false,
  tireAir: false,
  tireGrooveDepth: false,
  tireNoDamage: false,
  batteryFull: false,
  batteryElec: false,
  lampsNoDefect: false,
  lampsNoDamage: false,
  engineOil: false,
  engineFunbelt: false,
  engineNoDefect: false,
  speedControl: false,
  windowLiquid: false,
  windowWiper: false,
  equipEtc: false,
  driveRecorder: false,
  equipNavi: false,
  smokeBomb: false,
  tools: false,
  spareTire: false,
  triangular: false,
  repairKit: false,
  winch: false,
  carWashExterior: false,
  carWashInterior: false,
  scratchCheck: false,
  presence: false,
  exteriorCheck: "",
  interiorCheck: "",
  memo: "",
  signaturePath: "",
  isAgreement: false,

  // Other
  pdfRoute: "",
  isDisableButtons: {
    registration: true,
    complete: true,
    export: true,
  },
});
